import { SyncTableConfig } from "./types";

export const SMART_VIEWS_TABLE_CONFIG: SyncTableConfig = {
  shapeKey: "smart_views",
  table: "smart_views",
  columns: [
    "id",
    "associated_space_account_id",
    "smart_context_id",
    "derived_kind",
    "derived_internal_label",
    "value_json",
    "refreshed_at",
    "created_at",
    "updated_at",
  ],
  primaryKey: ["id"],
  parser: { timestamptz: (d: string) => new Date(d).toISOString() },
  enabled: false,
};
